import { render } from "./postList.vue?vue&type=template&id=828976e0&scoped=true&ts=true"
import script from "./postList.vue?vue&type=script&lang=ts"
export * from "./postList.vue?vue&type=script&lang=ts"

import "./postList.vue?vue&type=style&index=0&id=828976e0&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/OfferCloud2_FrontWebs_All/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-828976e0"]])

export default __exports__